import React, { useContext, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../../Helpers/Form/FormParts/FormHeader";
import { popupcontext } from "../../../../context/Popupscontext";
import ReportSheetsInput from "../ReportSheetsInput/ReportSheetsInput";
import Filter from "../../../Helpers/Filter/Filter";
import OffcanvasFooter from "../../../Helpers/Offcanvasfooter/OffcanvasFooter";
import trans from "../../../../utils";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

export default function ReportSheetsFilter({
	setStartDate,
	startDate,
	setEndDate,
	endDate,
	selectedUser,
	selectedVehicles,
	setSelectedUser,
	setSelectedVehicles,
	selectedGroupId,
	setSelectedGroupId,
	dueWithin,
	setDueWithin,
	setIsShown,
	isShown,
}) {
	const { form } = useContext(popupcontext);
	let { handleClose } = useContext(popupcontext);
	const [start, setStart] = useState("");
	const [end, setEnd] = useState("");
	const [items, setItems] = useState([]);
	const { pathname } = useLocation();
	const shortPath = pathname.split("/").pop();

	const handleCancel = () => {
		handleClose();
		setIsShown(false);
	};
	const handleShow = () => {
		const hasItems =
			(Array.isArray(items) && items.length > 0) ||
			(!Array.isArray(items) && items);
		const hasGroups = selectedGroupId && selectedGroupId.length > 0;
		const hasDueWithin = dueWithin !== "" && dueWithin !== null && dueWithin !== undefined;

		if (shortPath === "maintenance" && !hasItems && !hasGroups && !hasDueWithin) {
			toast.error(trans("Please select at least one maintenance filter"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			return;
		}

		if (shortPath !== "maintenance" && !hasItems) {
			toast.error(trans("Please select at least one vehicle"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			return;
		}

		if (shortPath !== "maintenance" && (!start || !end)) {
			toast.error(trans("Please Select Date Range"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			return;
		}
		setIsShown(true);
		handleClose("form");
	};
	useEffect(() => {}, []);
	return (
		<>
			<Filter show={form}>
				<Offcanvas.Header>
					<FormHeader title={trans("Report Filter")} />
				</Offcanvas.Header>
				<div className="H-line"></div>
				<Offcanvas.Body>
					<ReportSheetsInput
						startDate={startDate}
						setStartDate={setStartDate}
						endDate={endDate}
						setEndDate={setEndDate}
						selectedUser={selectedUser}
						selectedVehicles={selectedVehicles}
						setSelectedUser={setSelectedUser}
						setSelectedVehicles={setSelectedVehicles}
						isShown={isShown}
						setIsShown={setIsShown}
						setStart={setStart}
						setEnd={setEnd}
						setItems={setItems}
						start={start}
						end={end}
						items={items}
						selectedGroupId={selectedGroupId}
						setSelectedGroupId={setSelectedGroupId}
						dueWithin={dueWithin}
						setDueWithin={setDueWithin}
						shouldRefetchGroups={form}
					/>
					<OffcanvasFooter
						text={trans("Show")}
						isShown={isShown}
						setIsShown={setIsShown}
						val={endDate}
						onClick={handleShow}
						onClose={handleCancel}
					/>
				</Offcanvas.Body>
			</Filter>
		</>
	);
}
